'use strict';

var MainView = require('../views/Main');
var CommonPersonalSettingsView = require('commons/views/PersonalSettings');
var RolePersonalSettingsView = require('../views/PersonalSettings.js');

var BaseRouter            = require('commons/routers/Base');
var PayrollRouter         = require('./Payroll');
var EmployeeRouter        = require('./Employee');
var ReportRouter          = require('./Report');
var SettingsRouter        = require('./Settings');
var CalendarRouter        = require('./Calendar');
var GovernmentFormsRouter = require('./GovernmentForms');
var DashboardRouter       = require('./Dashboard');
var TimesheetRouter       = require('./Timesheet.js');
var moment                = require('moment');

module.exports = BaseRouter.extend({
    routes: {
        'personalSettings': 'personalSettings'
    },

    titles: {
        'personalSettings': 'Personal Settings'
    },

    initialize: function() {
        this.mainView = new MainView({model: app.company});

        this.subRouters = [
            new PayrollRouter({el: this.mainView.childEl}),
            new EmployeeRouter({el: this.mainView.childEl})
        ];

        /* MPP Managers only have access to Payroll and Employees */
        if (app.user.get('role') !== 'mpp_manager') {
            this.subRouters = this.subRouters.concat([
                new ReportRouter({el: this.mainView.childEl}),
                new SettingsRouter({el: this.mainView.childEl}),
                new GovernmentFormsRouter({el: this.mainView.childEl}),
                new DashboardRouter({el: this.mainView.childEl}),
                new CalendarRouter({el: this.mainView.childEl}),
                new TimesheetRouter({el: this.mainView.childEl})
            ]);
        }

        // TODO This is view logic, it does not belong in the router and should
        // be moved out
        Backbone.history.on('route', function() {
            this.mainView.setActiveLink(Backbone.history.getFragment());
            window.scrollTo(0, 0);
        }.bind(this));

        app.events.on('before:route', opts => {
            const fragment = opts.previousFragment || false;
            const activeRouter = this.subRouters.find(router => {
                let routes = Object.keys(router.routes);
                return (routes.indexOf(fragment) >= 0);
            });
            if (activeRouter && activeRouter.view) {
                if (activeRouter.view.remove) {
                    activeRouter.view.remove();
                }
            }
        });

        let impersonating = app.user.isAdmin();
        if (!impersonating) {
            app.company.save(
                {'lastActiveTime': moment.now()},
                {validate: false}
            );
        }
        if (app.company.get('updateRestricted')) {
            $('#update-restricted-notification').css({display: 'block'});
        }
        if (app.company.get('leaveRequestsMigrated')) {
            $('#leaves-migrated-notification').css({display: 'block'});
        }
        $('#help-notification').css({display: 'block'});
    },

    toggleFreeAccountSetup: function(show) {
        const button = $('.js-free-account-setup');
        if (show) {
            button.show();
        } else {
            button.hide();
        }
    },

    personalSettings: function() {
        this.undelegateEvents();

        // just hotfix for solve events mess
        // TODO: refactor events binding
        var el = $('<div></div>');
        $(this.mainView.childEl).html(el);

        this.view = new CommonPersonalSettingsView({
            el: el,
            model: app.user,
            subViews: app.user.get('role') === 'employer' ?
                [new RolePersonalSettingsView({
                    model: app.user,
                    company: app.company
                })] : []
        });
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Main.js